// ============================================================
// THEME: BENDER QUEST (ORIGINAL — PRE-RACING)
// ------------------------------------------------------------
// The original BenderQuest look from v1.0. Bender Extender's
// core year-round brand. No racing language anywhere — no pit
// stops, no pit crew, no refuel, no checkered flag. Just the
// pure product with pink + teal on black and the CARTO dark
// basemap.
// ============================================================

const bender = {
  id: 'bender',
  name: 'Bender Quest',
  short: 'BENDER',

  colors: {
    pink:   '#e683a9',   // primary accent  -> BENDER PINK
    teal:   '#78d5c3',   // secondary accent-> BENDER TEAL
    yellow: '#e6d027',   // tertiary/highlight -> placeholder, see note
    dark:   '#000000',   // app background  -> PURE BLACK
    panel:  '#18181b',   // cards / panels  -> zinc-900
    text:   '#ffffff',
  },

  raw: {
    accentPrimary:   '#e683a9',
    accentSecondary: '#78d5c3',
    glow:            '#e683a9',
    pinGlow:         '#e683a9',
    squadPin:        '#78d5c3',
    iconText:        '#e683a9',
    iconRing:        '#78d5c3',
  },

  branding: {
    logo:    '/bender-logo.png',
    logoAlt: 'Bender Extender',
    title:   'BENDER QUEST',
    titleAccent: 'QUEST',
    tagline: "Bend, don't break",
    footer:  'v1.0 • Protected by Bender Extender',
  },

  labels: {
    primaryAction:   'ADD DRINK',
    secondaryAction: 'HYDRATE',
    endSession:      'END BENDER',
    startSession:    'GO LIVE',
    squadLabel:      'SQUAD',
    squadCountFmt:   '{n} Members Active',
    rankingsLabel:   'RANKINGS',
    liveBadge:       'LIVE',
    statsHeader:     'Weekly Progress',
    durationLabel:   'DURATION',
    drinksLabel:     'DRINKS',
    stepsLabel:      'STEPS',
  },

  map: {
    // VECTOR basemap (preferred): OpenFreeMap "dark" — free, no API key, no
    // usage cap, and crisp at every zoom / pixel density (raster tiles go soft
    // on a 3× phone). Rendered by MapLibre via src/utils/basemap.js.
    styleUrl:        'https://tiles.openfreemap.org/styles/dark',
    // Raster fallback: Esri dark canvas — key-free (CARTO started requiring an
    // API key in 2026). Native tiles stop at z16; Leaflet upscales past that.
    tileUrl:         'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    labelsUrl:       'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
    tileSubdomains:  'abc',
    tileAttribution: '&copy; Esri',
    maxZoom:         20,
    maxNativeZoom:   16,
    containerBg:     '#18181b',
  },

  venueTypes: {
    default: { emoji: '🍸', bg: 'bg-zinc-800/80',   border: 'border-zinc-500' },
    partner: { emoji: '🍺', bg: 'bg-brand-pink/30', border: 'border-brand-pink' },
    supply:  { emoji: '💊', bg: 'bg-brand-teal/30', border: 'border-brand-teal' },
  },

  themeColor: '#000000',
  font: {
    display: "'Inter', sans-serif",
    mono:    "'JetBrains Mono', monospace",
  },
};

export default bender;
